import * as React from "react"
import { Autocomplete, Box, Button, Checkbox, CircularProgress, FormControl, InputLabel, MenuItem, Select, Slide, Tab, Tabs, TextField } from "@mui/material"
import Grid from "@mui/material/Grid2"
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs"
import { DatePicker } from "@mui/x-date-pickers";
import MenuIcon from '@mui/icons-material/Menu';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank"
import CheckBoxIcon from "@mui/icons-material/CheckBox"
import CashflowReport from "./Reports/Cashflow";
import CheckoutCheckinActivityReport from "./Reports/CheckOutInActivity";
import ServiceTechnicianWorkHistory from "./Reports/ServiceTechnicianWorkHistory";
import ServiceKPIsReport from "./Reports/ServiceKPIs";
import { useLocation } from "react-router-dom";
import TabPanel from "../Utils/tabpanel";
import DocumentTitle from "../Utils/DocumentTitle";
import ServiceOrderTurnTime from "./Reports/ServiceOrderTurnTime";
import { ServiceOrderServiceWorkloadWrapper } from "./Reports/ServiceOrderServiceWorkload";
import { useLocations } from "./ReactQuery/QueryLocations";
import { useTrackedLocation } from "./UserState";
import ServiceOrderPartTurnTime from "./Reports/ServiceOrderPartTurnTimes";
import ServiceServiceKitReport from "./Reports/ServiceServiceKitReport";
import Metrics from "./Reports/Metrics";
import ServiceOrderItemTypesReport from "./Reports/ServiceOrderItemTypesReport";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />

export default function Reports(props) {
    DocumentTitle('Reports')
    const location = useLocation();
    const { data: locations, isLoadingLocations } = useLocations();
    const [tab, setTab] = React.useState((location.hash || "#cashflow").substring(1))
    const [selectedLocation,] = useTrackedLocation();
    const [selectedLocations, setSelectedLocations] = React.useState((selectedLocation.id === 'all' ? structuredClone([...(locations ?? [])]) : [JSON.parse(JSON.stringify(selectedLocation))]) ?? [])
    const [selectedLocationsOpen, setSelectedLocationsOpen] = React.useState(false)
    const [newSelectedLocations, setNewSelectedLocations] = React.useState((selectedLocation.id === 'all' ? structuredClone([...(locations ?? [])]) : [JSON.parse(JSON.stringify(selectedLocation))]) ?? [])
    const [startDatetime, setStartDateTime] = React.useState(dayjs().utc().subtract(30, 'day').startOf('day'))
    const [endDatetime, setEndDateTime] = React.useState(dayjs().utc().endOf('day'))
    const [selectedPeriod, setSelectedPeriod] = React.useState(30)
    const [expandSidebar, setExpandSidebar] = React.useState(true)

    const handleLocationChange = (e, options, action, option) => {
        console.log(action, option)
        if (action === "removeOption") {
            if (!selectedLocationsOpen) {
                setSelectedLocations(structuredClone(selectedLocations.filter((item) => item.id !== option.option.id)))
            }
            setNewSelectedLocations(structuredClone(newSelectedLocations.filter((item) => item.id !== option.option.id)))
        } else {
            newSelectedLocations.push({ ...option.option })
            console.log(newSelectedLocations)
            setNewSelectedLocations(structuredClone(newSelectedLocations))
        }
    }

    React.useEffect(() => {
        if (!isLoadingLocations && selectedLocations.length === 0 && locations.length > 0) {
            setSelectedLocations(selectedLocation.id === 'all' ? structuredClone([...(locations ?? [])]) : [JSON.parse(JSON.stringify(selectedLocation))])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadingLocations, locations])

    React.useEffect(() => {
        window.history.replaceState(null, null, `#${tab}`)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tab])

    return (
        (<React.Fragment>
            <Box width={'100%'}>
                <Grid container spacing={2}>
                    <Grid size='auto'>
                        <Box>
                            <Button onClick={() => setExpandSidebar(!expandSidebar)}><MenuIcon /></Button>
                        </Box>
                        <Slide in={expandSidebar} direction="right" mountOnEnter unmountOnExit>
                            <Tabs
                                orientation="vertical"
                                variant="scrollable"
                                value={tab}
                                onChange={(e, value) => setTab(value)}
                                aria-label="reports"
                                sx={{ borderRight: 1, borderColor: 'divider' }}
                            >
                                <Tab label="Cashflow" value="cashflow" />
                                {/* <Tab label="Checkout Checkin Activity" value="checkoutcheckinactivity" /> */}
                                <Tab label="Service KPIs" value="servicekpis" />
                                <Tab label="Service Kit Report" value="servicekitreport" />
                                <Tab label="Service Technician Work History" value="serviceworkhistory" />
                                <Tab label="Service Order Turn Time" value="serviceorderturntime" />
                                <Tab label="Service Order Services Time To Work" value="serviceorderservicetimetowork" />
                                <Tab label="Service Order Parts Turn Times" value="serviceorderpartstatustimes" />
                                <Tab label="Service Order Item Types" value="serviceorderitemtypes" />
                                <Tab label="Metrics (BETA)" value="metrics" />
                            </Tabs>
                        </Slide>
                        {!expandSidebar && undefined
                        }
                    </Grid>
                    <Grid size="grow">
                        <Grid container justifyContent={'space-between'} alignItems={'center'} spacing={1}>
                            {!['serviceorderservicetimetowork', 'metrics'].includes(tab) &&
                                <Grid size="auto">
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Grid container spacing={1}>
                                            <Grid size="grow">
                                                <DatePicker
                                                    value={startDatetime}
                                                    label="Start Date"
                                                    onChange={(newValue) => {
                                                        setStartDateTime(newValue.startOf('day'))
                                                    }}
                                                    onAccept={(newValue) => {
                                                        setSelectedPeriod('custom')
                                                        if (newValue > endDatetime) {
                                                            setEndDateTime(newValue.endOf('day').add(1, 'days'))
                                                        }
                                                    }}
                                                    sx={{ width: '175px' }}
                                                />
                                            </Grid>
                                            <Grid size="grow">
                                                <DatePicker
                                                    value={endDatetime}
                                                    label="End Date"
                                                    onChange={(newValue) => {
                                                        setSelectedPeriod('custom')
                                                        setEndDateTime(newValue.endOf('day'))
                                                    }}
                                                    sx={{ width: '175px' }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </LocalizationProvider>
                                </Grid>
                            }
                            {!['serviceorderservicetimetowork', 'metrics'].includes(tab) &&
                                <Grid size="auto">
                                    <FormControl>
                                        <InputLabel id="reports-time-category">Period</InputLabel>
                                        <Select
                                            labelId="reports-time-category"
                                            label="Period"
                                            placeholder=''
                                            onChange={(event) => {
                                                setSelectedPeriod(event.target.value)
                                                if (event.target.value !== 'custom') {
                                                    setStartDateTime(dayjs().utc().subtract(event.target.value, 'day').startOf('day'))
                                                    setEndDateTime(dayjs().utc().endOf('day'))
                                                }
                                            }}
                                            value={selectedPeriod}
                                            sx={{ width: '115px' }}
                                        >
                                            <MenuItem key="30" value={30}
                                            >
                                                30 days
                                            </MenuItem>
                                            <MenuItem key="60" value={60}
                                            >
                                                60 days
                                            </MenuItem>
                                            <MenuItem key="90" value={90}
                                            >
                                                90 days
                                            </MenuItem>
                                            <MenuItem key="custom" value={'custom'}
                                            >
                                                Custom
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            }
                            <Grid size="grow">
                                {isLoadingLocations &&
                                    <Grid container justifyContent={'center'} alignItems={'center'} spacing={1}>
                                        <Grid item>
                                            <CircularProgress />
                                        </Grid>
                                        <Grid item>
                                            <span>Loading Locations...</span>
                                        </Grid>
                                    </Grid>
                                }
                                {!isLoadingLocations &&
                                    <Autocomplete
                                        multiple
                                        disableCloseOnSelect
                                        clearIcon={<div></div>}
                                        sx={{ width: "100%", p: 1, pl: 0 }}
                                        onChange={handleLocationChange}
                                        onOpen={(e) => setSelectedLocationsOpen(true)}
                                        onClose={(e) => {
                                            if (JSON.stringify(newSelectedLocations.sort()) !== JSON.stringify(selectedLocations.sort())) {
                                                setSelectedLocations(structuredClone(newSelectedLocations))
                                            }
                                            setSelectedLocationsOpen(false)
                                        }}
                                        getOptionLabel={(option) => option.name}
                                        value={newSelectedLocations}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        options={locations}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                    value={option.id}
                                                />
                                                {`${option.name || ""}`}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Locations"
                                                placeholder="Locations"
                                            />
                                        )}
                                    />
                                }
                            </Grid>
                        </Grid>
                        <hr />
                        <Box>
                            <TabPanel value={tab} value_key={"cashflow"}>
                                <CashflowReport
                                    startDatetime={startDatetime}
                                    endDatetime={endDatetime}
                                    selectedLocations={selectedLocations}
                                />
                            </TabPanel>
                            <TabPanel value={tab} value_key={"checkoutcheckinactivity"}>
                                <CheckoutCheckinActivityReport
                                    startDatetime={startDatetime}
                                    endDatetime={endDatetime}
                                    selectedLocations={selectedLocations}
                                />
                            </TabPanel>
                            <TabPanel value={tab} value_key={"servicekpis"}>
                                <ServiceKPIsReport
                                    startDatetime={startDatetime}
                                    endDatetime={endDatetime}
                                    selectedLocations={selectedLocations}
                                />
                            </TabPanel>
                            <TabPanel value={tab} value_key={"servicekitreport"}>
                                <ServiceServiceKitReport
                                    startDatetime={startDatetime}
                                    endDatetime={endDatetime}
                                    selectedLocations={selectedLocations}
                                />
                            </TabPanel>
                            <TabPanel value={tab} value_key={"serviceworkhistory"}>
                                <ServiceTechnicianWorkHistory
                                    startDatetime={startDatetime}
                                    endDatetime={endDatetime}
                                    selectedLocations={selectedLocations}
                                />
                            </TabPanel>
                            <TabPanel value={tab} value_key={"serviceorderturntime"}>
                                <ServiceOrderTurnTime
                                    startDatetime={startDatetime}
                                    endDatetime={endDatetime}
                                    selectedLocations={selectedLocations}
                                />
                            </TabPanel>
                            <TabPanel value={tab} value_key={"serviceorderservicetimetowork"}>
                                <ServiceOrderServiceWorkloadWrapper
                                    startDatetime={startDatetime}
                                    endDatetime={endDatetime}
                                    selectedLocations={selectedLocations}
                                />
                            </TabPanel>
                            <TabPanel value={tab} value_key={"serviceorderpartstatustimes"}>
                                <ServiceOrderPartTurnTime
                                    startDatetime={startDatetime}
                                    endDatetime={endDatetime}
                                    selectedLocations={selectedLocations}
                                />
                            </TabPanel>
                            <TabPanel value={tab} value_key={"serviceorderitemtypes"}>
                                <ServiceOrderItemTypesReport
                                    startDatetime={startDatetime}
                                    endDatetime={endDatetime}
                                    selectedLocations={selectedLocations}
                                />
                            </TabPanel>
                            <TabPanel value={tab} value_key={"metrics"}>
                                <Metrics
                                    selectedLocations={selectedLocations}
                                />
                            </TabPanel>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </React.Fragment >)
    );
}
